// src/utils/paramsHelper.js

/**
 * Replaces template variables in params object with actual values
 * @param {Object} params - The params object containing template strings
 * @param {Object} context - Object containing values to replace (e.g., { year, month, contract })
 * @returns {Object} - New params object with replaced values
 */
export const processParams = (params, context , override ={}) => {
    if (!params) return {};
    
    const processedParams = {};
    
    for (const key in params) {
        let value = params[key];
        
        if (typeof value === 'string') {
            // Replace {{year}}, {{month}}, {{contract}} etc.
            value = value.replace(/\{\{(\w+)\}\}/g, (match, paramName) => {
                return context[paramName] !== undefined ? context[paramName] : match;
            });
        }
        
        processedParams[key] = value;
    }

    // processedParams.is_cfo = false;
    // processedParams.is_cfo = override?.is_cfo ? override?.is_cfo : false;
    // processedParams.is_cfo = override.is_cfo !== undefined ? override.is_cfo : false;
    
    return processedParams;
};